import { ConstellationOneListing, MLSAttributionMap } from '@aloft/toolkit-shared';
import { Flex, Typography } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra
import { Image } from '@aloft/toolkit-sui/chakra';

const MLSAttributionInfo = ({ listingData }: { listingData: ConstellationOneListing }) => {
  const osn = listingData.OriginatingSystemName;

  // No OSN means we're using backup listing data
  if (!osn) {
    return null;
  }
  const mlsAttribution = osn ? MLSAttributionMap[osn] : undefined;
  const logoURL = mlsAttribution ? mlsAttribution.logoURL : undefined;
  const disclaimerText = mlsAttribution ? mlsAttribution.disclaimer(listingData) : '';
  return (
    <Flex marginTop="1rem" flexDirection="column">
      {logoURL && <Image height={5} src={logoURL} alignSelf="flex-start" />}
      <Typography variant="body1" color="textTertiary">
        {disclaimerText}
        <br />
        <a target="_blank" href="https://www.homeservices.com/licensing" rel="noreferrer">
          Licensing provided by the National Broker Network
        </a>
        <br />
        {listingData.LastSyncDate
          ? `Last Checked: ${new Date(listingData.LastSyncDate).toLocaleString()}`
          : ''}
      </Typography>
    </Flex>
  );
};

export default MLSAttributionInfo;
